/**
 * スライドの状態を更新
 */

import { IMAGE_COUNT } from './config.js';
import { initManualScramble } from './textAnime.js';

const numEl = document.querySelector('[data-slide-num]');
const ttlEl = document.querySelector('[data-slide-ttl]');
const dateEl = document.querySelector('[data-slide-date]');
const datetimeEl = document.querySelector('[data-slide-datetime]');
const hiddenItemList = document.querySelectorAll('[data-slide-hiddenItem]');
const animeTargetList = document.querySelectorAll('[data-scramble-anime-target]');
let currentActiveIndex = -1;

/**
 * 現在のカルーセル回転角(rotationY)から「正面にいるスライド番号」を計算する
 * @param {number} rotationY - 現在のカルーセル回転角
 * @return {number} - 正面にいるスライド番号
 */
export const getActiveIndex = rotationY => {
	// 隣のスライドまでの角度
	const step = (Math.PI * 2) / IMAGE_COUNT;
	// rotationY / step→何枚分回転したか
	// Math.round((-rotationY / step)→一番近いスライド番号
	return (
		Math.round((-rotationY / step)) %
		IMAGE_COUNT + IMAGE_COUNT
	) % IMAGE_COUNT;
};

/**
 * Active / Prev / Next判定
 */
export const updateSlideStates = ({
	rotateGroup,
	rotationY,
}) => {
	changeTxtData({ rotationY, rotateGroup });
	const activeIndex = getActiveIndex(rotationY);
	const prevIndex = (activeIndex - 1 + IMAGE_COUNT) % IMAGE_COUNT;
	const nextIndex = (activeIndex + 1) % IMAGE_COUNT;
	rotateGroup.children.forEach(
		(mesh, index) => {
			if (index === activeIndex) {
				mesh.userData.state = 'active';
				return;
			}
			if (index === prevIndex) {
				mesh.userData.state = 'prev';
				return;
			}
			if (index === nextIndex) {
				mesh.userData.state = 'next';
				return;
			}
			mesh.userData.state = 'other';
		}
	);
};

/**
 * スライドが持つdata（number,title,date）を変更
 * @param {*} param0 
 */
const changeTxtData = ({
	rotationY,
	rotateGroup
}) => {
	if (!numEl || !ttlEl || !dateEl || !animeTargetList.length) {
		return;
	}
	const activeIndex = getActiveIndex(rotationY);
	// activeスライドが変わった時に番号とタイトルを更新する
	if (activeIndex !== currentActiveIndex) {
		// 現在のactiveスライドを更新
		currentActiveIndex = activeIndex;
		// 指定のDOMにmeshデータを挿入
		const activeMesh = rotateGroup.children[getActiveIndex(rotationY)];
		const num = String(activeMesh.userData.index + 1);
		numEl.textContent = '#' + num.padStart(2, '0');
		ttlEl.innerHTML = activeMesh.userData.title;
		dateEl.textContent = activeMesh.userData.date;
		// 公開日をdatetime属性に入れるために変換する
		if (datetimeEl) {
			datetimeEl.setAttribute('datetime', (activeMesh.userData.date).replace(/\./g, '-'));
		}

		// スクランブルアニメーション実行
		initManualScramble(animeTargetList);

		// アクセシビリティ対策
		hiddenItemList.forEach((hiddenItem, index) => {
			if (index === activeIndex) {
				hiddenItem.setAttribute(
					'aria-current',
					'true'
				);
			} else {
				hiddenItem.removeAttribute(
					'aria-current'
				);
			}
			hiddenItem.tabIndex = index === activeIndex ? 0 : -1;
		});
	}
};
